<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @closed="closed"
             width="600px">
    <div style="margin: 20px 110px 0 80px">
      <el-form label-position="right" label-width="90px" :model="goods" :rules="rules" ref="goods">
        <input-form-item label="商品编号" prop="code"></input-form-item>
        <input-form-item label="商品名称" prop="name"></input-form-item>
        <remote-form-item label="商品类型" class-name="GOODS_TYPE" prop="typeCode" using-code></remote-form-item>
        <input-form-item label="商品单位" prop="unit"></input-form-item>
        <input-form-item label="商品单价" prop="price" number></input-form-item>
        <remote-form-item label="供应商" prop="supplierCode" class-name="SUPPLIER" using-code></remote-form-item>
        <textarea-form-item label="备注" prop="remarks"></textarea-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()">新 增</el-button>
      <el-button v-else-if="!readOnly" type="primary" @click="save()">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

import InputFormItem from '@/components/form/InputFormItem'
import TextareaFormItem from '@/components/form/TextareaFormItem'
import RemoteFormItem from '@/components/form/RemoteFormItem'

export default {
  name: 'EditGoodsDialog',
  components: {
    RemoteFormItem,
    TextareaFormItem,
    InputFormItem
  },
  props: {
    goods: {
      type: Object,
      required: true
    },
    readOnly: Boolean
  },
  data () {
    return {
      rules: {
        name: [
          {
            required: true,
            message: '请输入商品名称',
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: '请输入商品编号',
            trigger: 'blur'
          }
        ],
        unit: [
          {
            required: true,
            message: '请输入商品单位',
            trigger: 'blur'
          }
        ],
        price: [
          {
            required: true,
            message: '请输入商品单价',
            trigger: 'blur'
          }
        ],
        supplierCode: [
          {
            required: true,
            message: '请选择商品供应商',
            trigger: 'change'
          }
        ],
        typeCode: [
          {
            required: true,
            message: '请选择商品类型',
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    closed () {
      if (!this.readOnly) {
        this.$refs.goods.resetFields()
      }
    },
    add () {
      this.$refs.goods.validate(valid => {
        if (!valid) return

        this.$store.dispatch('goods/add', this.$_.cloneDeep(this.goods)).then(() => {
          this.hide()
          this.$message.success('添加成功!')
        })
      })
    },
    save () {
      this.$refs.goods.validate(valid => {
        if (!valid) return

        this.$store.dispatch('goods/updateOne', this.$_.cloneDeep(this.goods)).then(() => {
          this.hide()
        })
      })
    },
    cancel () {
      this.hide()
    },
    hide () {
      this.$emit('update:visible', false)
    }
  },
  computed: {
    isNew () {
      return !this.goods.id
    },
    controlReadOnly () {
      return !this.isNew && this.readOnly
    },
    title () {
      if (this.isNew) return '新增商品'
      return this.readOnly ? '商品详细信息' : '编辑商品'
    }
  }
}
</script>
